import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import './ErrorBoundary.css';

/**
 * React Error Boundary -- catches render errors in child components.
 * Shows a clean error message ONCE with a retry button.
 * Does NOT loop or repeat the error.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error exactly once
    console.error('[ErrorBoundary] Caught render error:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const { fallbackTitle, fallbackMessage } = this.props;

      return (
        <div className="error-boundary">
          <div className="error-boundary-card">
            <AlertTriangle size={32} strokeWidth={1.5} className="error-boundary-icon" />
            <h3 className="error-boundary-title">
              {fallbackTitle || 'Something went wrong'}
            </h3>
            <p className="error-boundary-message">
              {fallbackMessage || 'An unexpected error occurred. Please try again.'}
            </p>
            <button
              className="error-boundary-retry"
              onClick={this.handleRetry}
            >
              <RefreshCw size={14} />
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
